export * from './details-tile-widget.component';
